'use client';

import { useMemo, type FC } from 'react';
import { Link } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { Wallet } from 'lucide-react';
import { useAuiState } from '@assistant-ui/react';

/** Same charge path as chat onboarding. */
export const AI_WALLET_CHARGE_PATH = '/prorogate-or-upgrade/?wallet=500000';

export type McpInsufficientWallet = {
  code: string;
  message: string;
};

function readInsufficientWallet(value: unknown): McpInsufficientWallet | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  const row = value as Record<string, unknown>;
  const code = typeof row.code === 'string' ? row.code.trim() : '';
  const message = typeof row.message === 'string' ? row.message.trim() : '';
  if (!code || !message) return null;
  return { code, message };
}

/** Alert + charge CTA when Omni is blocked due to empty AI wallet. */
export const McpInsufficientWalletAlert: FC = () => {
  const walletKey = useAuiState((s) => {
    if (s.message.role !== 'assistant') return '';
    const raw = s.message.metadata?.custom?.insufficientWallet;
    if (!raw || typeof raw !== 'object') return '';
    try {
      return JSON.stringify(raw);
    } catch {
      return '';
    }
  });

  const wallet = useMemo(
    () => (walletKey ? readInsufficientWallet(JSON.parse(walletKey)) : null),
    [walletKey],
  );

  if (!wallet) return null;

  return (
    <div className="mt-3">
      <Alert
        variant="warning"
        className="mcp-wallet-alert mb-0 py-2 px-3 fs--1 w-full d-flex flex-column align-items-start gap-2"
      >
        <p className="mb-0 w-full">
          <Wallet
            className="me-2 align-text-bottom"
            size={16}
            strokeWidth={2}
            aria-hidden
          />
          {wallet.message}
        </p>
        <Link
          to={AI_WALLET_CHARGE_PATH}
          className="btn btn-sm btn-falcon-primary"
        >
          شارژ اعتبار AI
        </Link>
      </Alert>
    </div>
  );
};
